export default __webpack_public_path__ + "static/media/mail-campaign.c0c372a3.svg";